import React from 'react';
import { SmartTagsTextInputLayoutProps } from 'ui-builder';
import BaseTagsInputLayout from './BaseTagsInputLayout';

export default function SmartTagsTextInputLayout(props: SmartTagsTextInputLayoutProps) {
  return (
    <BaseTagsInputLayout {...props} />
  );
}
